export const SECTION_NAME = "ReturnToVendor";

export const INTRO_TEXT = `A return to vendor, or RTV, is a transaction in which goods are returned due to an erroneous shipment or  damage during delivery.`;

export const EXAMPLE_JSON = `{
    "id": 123,
    "starred": 0,
    "syncToken": 0,
    "number": "IR-12345",
    "date": "2019-05-08T09:13:00",
    "vendor": {
      "id": 23,
      "name": "ABC Plastics"
    },
    "location": {
      "id": 1,
      "name": "Warehouse"
    },
    "account": {
      "id": 107,
      "name": "Cash on hand"
    }
    "department": null,
    "shippingMethod": {
      "id": 11,
      "name": "FedEx"
    },
    "trackingNumber": "GVZ382398GF899S2",
    "linkedTransaction": null,
    "comment": null,
    "vendorNotes": "",
    "customFields": [
      {
        "id": 5,
        "name": "Checkbox",
        "value": "false",
        "dataType": "Boolean"
      },
      {
        "id": 13,
        "name": "Our-Acct-No",
        "value": "ABC84729",
        "dataType": "String"
      }
    ],
    "total": 12,
    "archived": false,
    "summaryOnly": false,
    "hasSignature": false,
    "createVendorCredit": false,
    "keys": null,
    "values": null,
    "lines": [
      {
        "id": 123345,
        "lineNumber": 1,
        "item": {
          "id": 851,
          "name": "Widget"
        },
        "vendorPartNumber": null,
        "class": null,
        "job": null,
        "workcenter": null,
        "customer": null,
        "tax": {
          "taxable": false,
          "taxCode": {
            "id": 3,
            "name": "NON"
          }
        },
        "linkedTransaction": null,
        "description": null,
        "quantity": 1,
        "weight": 12,
        "volume": 12,
        "weightunit": "lb",
        "volumeunit": "cbm",
        "unitprice": 12,
        "amount": 12,
        "received": 0,
        "uom": {
          "id": 1,
          "name": "each"
        },
        "bin": null,
        "lot": {
          "id": 17,
          "name": "B24XP9381"
        },
        "lotExpiration": null,
        "serials": [
          {
            "id": 837,
            "name": "48147G489"
          },
          {
            "id": 845,
            "name": "48147G498"
          }
        ]
      }
    ],
  }`;

export const ATTRIBUTES = [
  {
    name: "id",
    type: "integer",
    description:
      "Unique identifier for this record. ID field is ignored on create requests."
  },
  {
    name: "starred",
    type: "integer",
    description: `Indicates if this item receipt has been starred. A value of 0 = no star; 1 or 1-3 = starred. Star colors 
      depend on application configuration. This could be one color of star or three colors of stars. See Company Settings in the user guide for more details.`
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record. If you receive an error when updating a record, it is because your syncToken is for an older version of the record than that which is currently in the database. Please GET the latest version prior to updating.`
  },
  {
    name: "number",
    type: "string",
    description: `The order number for this record.  If you wish to use the automatic numbering capability 
    on creation of a item receipt, pass the string “auto”.`
  },
  {
    name: "date",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS",
    description: `Transaction date.`
  },
  {
    name: "vendor",
    type: "reference",
    description: "Vendor from which these items were received."
  },
  {
    name: "location",
    type: "reference",
    description: `Location where these items were stored.`
  },
  {
    name: "account",
    type: "reference",
    description: `Account to which the transaction amount should be debited.`
  },
  {
    name: "department",
    type: "reference",
    description: `Department for this transaction.`
  },
  {
    name: "shippingMethod",
    type: "reference",
    description: `Shipping method for transaction.`
  },
  {
    name: "trackingNumber",
    type: "string",
    description: `The carrier's tracking number for this RTV.`
  },
  {
    name: "linkedTransaction",
    type: "linked transaction type",
    description: `The transaction linked to this RTV.`
  },
  {
    name: "comment",
    type: "string",
    description:
      "The company’s internal comment about this transaction. This comment is not visible to the vendor."
  },
  {
    name: "vendorNotes",
    type: "string",
    description: `Field for internal notes about vendor.`
  },
  {
    name: "customFields",
    type: "array of custom fields",
    description: `The list of custom fields for this object type.`
  },
  {
    name: "total",
    type: "decimal",
    description: `Transaction total`,
    readOnly: true
  },
  {
    name: "archived",
    type: "boolean",
    description: `True if item is archived, false if not.`,
    readOnly: true
  },
  {
    name: "summaryOnly",
    type: "boolean",
    description: `Indicates if the summary parameter was set when retrieving back this record`,
    readOnly: true
  },
  {
    name: "hasSignature",
    type: "",
    description: `Reserved for future use.`,
    readOnly: true
  },
  {
    name: "createVendorCredit",
    type: "boolean",
    description: `Send a vendor credit to accounting software?`,
    readOnly: true
  },
  {
    name: "keys",
    type: "",
    description: `Reserved for future use.`
  },
  {
    name: "values",
    type: "",
    description: `Reserved for future use.`
  },
  {
    name: "lines",
    type: "array of return to vendor lines",
    description: "The lines for this RTV.  See object structure below."
  }
];

export const LINE_ITEM = [
  {
    name: "id",
    type: "integer",
    description: `The unique identifier for this RTV item. ID field is ignored on create requests.`
  },
  {
    name: "lineNumber",
    type: "integer",
    description: `The line number for this line on the RTV transaction.`
  },
  {
    name: "item",
    type: "reference",
    description: `The item this line represents.`
  },
  {
    name: "vendorPartNumber",
    type: "string",
    description: `Self-explanatory.`
  },
  {
    name: "class",
    type: "reference",
    description: `The class for this line.`
  },
  {
    name: "job",
    type: "reference",
    description: `The job for this line, if enabled.`
  },
  {
    name: "workcenter",
    type: "reference",
    description: `The related work center for the job.`
  },
  {
    name: "customer",
    type: "reference",
    description: "The customer this line item is targeted for, if any."
  },
  {
    name: "tax",
    type: "tax information object",
    description: `The tax information for this line, if enabled.`
  },
  {
    name: "linkedTransaction",
    type: "linked transaction type",
    description: `The transaction linked to this line.`
  },
  {
    name: "description",
    type: "string",
    description: `The item description.`
  },
  {
    name: "quantity",
    type: "decimal",
    description: `The quantity for this line item.`
  },
  {
    name: "weight",
    type: "decimal",
    description: `The weight of this line.`,
    readOnly: true
  },
  {
    name: "volume",
    type: "decimal",
    description: `The volume of this line.`,
    readOnly: true
  },
  {
    name: "weightunit",
    type: "string",
    description: `The unit for the item's weight value.`,
    readOnly: true
  },
  {
    name: "volumeunit",
    type: "string",
    description: `The unit for the item's volume value.`,
    readOnly: true
  },
  {
    name: "unitPrice",
    type: "decimal",
    description: `The unit price for this item.  Must be above the item’s minimum price, if set.`
  },
  {
    name: "amount",
    type: "decimal",
    description: `The purchase price for this line item. The amount must equal the quantity multiplied by the unit price.`
  },
  {
    name: "received",
    type: "decimal",
    description: `The quantity of this line item that was received.`
  },
  {
    name: "uom",
    type: "reference",
    description: `The unit of measure for this line.`
  },
  {
    name: "bin",
    type: "reference",
    description: "Unused."
  },
  {
    name: "lot",
    type: "reference",
    description: "Unused."
  },
  {
    name: "lotExpiration",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS",
    description: `Unused.`
  },
  {
    name: "serials",
    type: "array of references",
    description: "Unused."
  }
];

export const QUERY_PARAMS = [
  {
    name: "start",
    type: "number",
    description: `A cursor used in pagination.  This is the row number of the full set of results. 
     The API limits results to a max of 200 results per call.  If you want to retrieve the next set
      of results you can use this parameter to retrive the next set of results.  For example if you
       are retrieving 200 results at a time, you can set start=201 to retrieve the next page of results.`
  },
  {
    name: "maxresults",
    type: "number",
    description: `The maximum number of results you want to return.  The default is 200, the maximum value allowed.`
  },
  {
    name: "status",
    type: "open/closed",
    description: `Filters results by whether the transaction is open or closed.`
  },
  {
    name: "query",
    type: "string",
    description: `This parameter will filter the results by matches of the string on the following fields: number, id, comment, vendor name, or location name.`
  },
  {
    name: "archived",
    type: "string",
    description: `"yes": return only archived transactions; "no": return only
      transactions that have not been archived.`
  },
  {
    name: "location",
    type: "string",
    description: `Filters transactions according to the name of the location.`
  },
  {
    name: "from/to",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS",
    description: `Returns records based on the beginning and ending transaction dates specified. Both parameters are optional. Using only one parameter allows filtering in one direction. Example:
    from=2019-09-01T00:00:00&to=2019-09-10T00:00:00
   `
  },
  {
    name: "createdsince/updatedsince",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS ",
    description: `Filters transactions created or updated since a specified date/time.`
  }
];

export const SAMPLE_QUERY_REQUEST =
  "/api/v2/returntovendor?start=101&maxresults=100&status=open&location=WHSE10&from=2019-05-01T00:00:00&to=2019-05-31T00:59:59&createdsince=2019-09-10T00:00:00&updatedsince=2019-09-10T23:59:59";
